import * as React from 'react';
import UIAccordionItem from 'UIComponents/accordion/UIAccordionItem';
import ValidationResultLabel from 'flow-doctor-lib/components/diagnosis/non-enrollment/validation/ValidationResultLabel';
import ValidationResultExplanation from 'flow-doctor-lib/components/diagnosis/non-enrollment/validation/ValidationResultExplanation';
import { jsx as _jsx } from "react/jsx-runtime";
const EnrollmentValidationResultAccordion = ({
  open,
  onOpenChange,
  validationResult,
  flowRevision,
  objectId
}) => {
  return /*#__PURE__*/_jsx(UIAccordionItem, {
    open: open !== null && open !== void 0 ? open : undefined,
    onOpenChange: () => onOpenChange === null || onOpenChange === void 0 ? void 0 : onOpenChange(!open),
    title: /*#__PURE__*/_jsx(ValidationResultLabel, {
      validationResult: validationResult,
      flowRevision: flowRevision
    }),
    children: /*#__PURE__*/_jsx("p", {
      children: /*#__PURE__*/_jsx(ValidationResultExplanation, {
        validationResult: validationResult,
        flowRevision: flowRevision,
        objectId: objectId
      })
    })
  });
};
export default EnrollmentValidationResultAccordion;